export default __webpack_public_path__ + "static/media/PPI-steps-007.9967ff10.jpg";